import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage} from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const SweetShop = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/SweetShops/Point-of-Sale.webp",
            tag: "Point of sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Fast billing for sweets, snacks & more.",
            desc: "QueueBuster’s POS billing software makes every transaction smooth — whether it’s for laddoos, rasgullas, namkeen, or milkcakes. Handle dine-in, takeaway, or bulk festive orders with ease, ensuring a sweet experience for your customers every time.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>Apply different prices for mithai boxes, loose items, or combo packs. </>,
                <>Scan barcodes or select items from a visual menu for speedy checkout.</>,
                <>Accept UPI, cash, cards, or digital wallet payments instantly. </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/SweetShops/RecipeManagement.webp",
            tag: "Recipe Management",
            icon: "/assets/outlet/SweetShops/RecipeManagement.svg",
            title: "Stock up your best-selling sweets & ingredients",
            desc: "Track every ingredient and mithai recipes in your sweet shop with smart inventory controls. From sugar and ghee to milk and packaging materials, stay stocked without over-ordering.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>Set minimum stock levels for ingredients and items like boxes or gift packaging.</>,
                <>Track expiry dates and batch-wise usage to reduce waste.</>,
                <>Get automatic restock alerts before popular items run out.</>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/SweetShops/eStore.webp",
            tag: "eStore",
            icon: "/assets/outlet/BookStores/eStore.svg",
            title: "Take your sweet shop online in minutes",
            desc: "Not everyone can make it to your store. With QueueBuster, you can set up your online sweet shop and accept orders for delivery or pickup anytime. Perfect for festive rush or catering bulk orders.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>Build an online sweet store without any technical skills.</>,
                <>Upload sweet images, prices, and combos with descriptions.</>,
                <>Share your store link via WhatsApp or social media for more orders.</>
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/SweetShops/Reporting.webp",
            tag: "Reporting",
            icon: "/assets/outlet/BookStores/Reports&Insights.svg",
            title: "Real-time reports for smarter decisions",
            desc: "Know what sells, what’s trending, and when your business peaks — all with 80+ detailed reports. With QueueBuster, you can focus on scaling your sweet shop while keeping all the numbers in check.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>View sales by item, time, staff, or outlet. </>,
                <>Monitor profit margins, wastage, and ingredient usage.</>,
                <>Generate tax and GST-compliant reports with a click.</>,
            ],
        },
        {
            id: 5,
            image: "/assets/outlet/SweetShops/CRM&Loyalty-Programs.webp",
            tag: "CRM & Loyalty ",
            icon: "/assets/outlet/BookStores/CRM&Loyalty-Programs.svg",
            title: "Make every customer a loyal one",
            desc: "Whether it’s regular customers or festive bulk buyers, QueueBuster’s CRM tools help you create strong connections. Offer deals on festivals, remember preferences, and reward repeat customers.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>Segment customers and run targeted offers for Diwali, Rakhi, or birthdays.</>,
                <>Reward returning customers with sweet discounts and points.</>,
                <>Store customer order history and preferences for faster service.</>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                   What makes QueueBuster POS ideal for sweet shops?
                </span>
            ),
            des: <>QueueBuster POS is specially crafted for Indian sweet shops and mithai stores. It helps manage itemized billing, combo offers, ingredient tracking, expiry handling, and loyalty features. Whether you're running a single counter or a chain, it’s built to simplify every aspect of your business.</>,
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does QueueBuster’s inventory management benefit my sweet shop?
                </span>
            ),
            des: <>Track ingredients like sugar, milk, and dry fruits with expiry dates, manage finished goods inventory, and receive alerts when key items are running low. It ensures nothing goes to waste and your shelves are always full.</>,
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Can I handle online orders using QueueBuster POS?
                </span>
            ),
            des: <>Yes! The eStore feature helps you create your sweet shop’s online store. You can list sweets, combos, festive packs, and more — and share the order link with customers through WhatsApp or SMS.</>,
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What payment modes are supported?
                </span>
            ),
            des: <>QueueBuster supports UPI, cash, credit/debit cards, and digital wallets. This makes it easy for your customers to pay the way they prefer.</>,
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Is my business data secure with QueueBuster?
                </span>
            ),
            des: <>Absolutely. QueueBuster uses top-tier encryption, role-based access, and regular backups to ensure your business data is always safe and only accessible by authorized staff.</>,
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                  How do I get started with QueueBuster’s POS for sweet shops?
                </span>
            ),
            des: <>Getting started is easy. Download the QueueBuster app, choose “My Online Store,” and start adding your sweets and combos. You’ll have a professional POS setup and online store running in no time — no technical knowledge needed!</>,
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How do loyalty programs work for sweet shop customers?
                </span>
            ),
            des:  <>With QueueBuster, you can reward loyal customers by tracking their purchases and offering them exclusive discounts, free items, or festive offers. You can even personalize offers based on past purchases.</>,
            id: 7,
            activeIndex: 0,
        },
       
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/SweetShops/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>PPOS Billing Software for</span> <span></span>
                                <span>&nbsp;Sweet Shop</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Running your sweet shop is now as delightful as a fresh batch of jalebis with QueueBuster’s Sweet Shop POS Billing Software. From traditional mithai to modern desserts, managing your inventory and billing is just a few taps away. Say goodbye to chaos and keep everything sweet, well managed, and on point!
                            </p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/SweetShops/hero-img.webp"
                            heading={<>POS Billing Software for </>}
                            staticHeading={<> Sweet Shop</>}
                            description={"Running your sweet shop is now as delightful as a fresh batch of jalebis with QueueBuster’s Sweet Shop POS Billing Software. From traditional mithai to modern desserts, managing your inventory and billing is just a few taps away. Say goodbye to chaos and keep everything sweet, well managed, and on point!"}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "50%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Delicious Features of QueueBuster’s POS Billing Software for Sweet Shop</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={" FAQ’s for the QueueBuster POS sweet shop billing software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQ’s for the QueueBuster POS sweet shop billing software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}



export default SweetShop